import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

function SheEarnsIntroducerIncome() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showSample, setShowSample] = useState(false);
  const [periodType, setPeriodType] = useState("Monthly");
  const [fromDate, setFromDate] = useState("2025-11-01");
  const [toDate, setToDate] = useState("2025-11-10");
  const [selectedLevel, setSelectedLevel] = useState("All");
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  const dummyRecords = [
    { id: 1, period: "November 2025", level: "L1", sn: 1, fromDate: "2025-11-01", toDate: "2025-11-10", amount: 5000 },
    { id: 2, period: "November 2025", level: "L1", sn: 2, fromDate: "2025-11-11", toDate: "2025-11-20", amount: 3000 },
    { id: 3, period: "November 2025", level: "L2", sn: 1, fromDate: "2025-11-01", toDate: "2025-11-30", amount: 2000 },
    { id: 4, period: "Q4 2025", level: "L1", sn: 1, fromDate: "2025-10-01", toDate: "2025-12-31", amount: 15000 },
    { id: 5, period: "Q4 2025", level: "L3", sn: 1, fromDate: "2025-10-01", toDate: "2025-12-31", amount: 8000 },
    { id: 6, period: "2025", level: "L1", sn: 1, fromDate: "2025-01-01", toDate: "2025-12-31", amount: 50000 },
    { id: 7, period: "Week 45 2025", level: "L2", sn: 1, fromDate: "2025-11-03", toDate: "2025-11-09", amount: 1500 },
    { id: 8, period: "November 2025", level: "L4", sn: 1, fromDate: "2025-11-01", toDate: "2025-11-30", amount: 4000 },
  ];

  const dummyContributors = {
    1: [
      { sn: 1, userName: "Priya Patel", product: "Immersive Learning Course", amount: 2000, commission: 500 },
      { sn: 2, userName: "Neha Gupta", product: "Digital Workshop", amount: 1500, commission: 375 },
      { sn: 3, userName: "Amit Joshi", product: "Podcast Subscription", amount: 1500, commission: 375 },
    ],
    2: [
      { sn: 1, userName: "Suresh Kumar", product: "Book Club Membership", amount: 1000, commission: 250 },
      { sn: 2, userName: "Ritu Devi", product: "Referral Link Share", amount: 2000, commission: 500 },
    ],
    3: [
      { sn: 1, userName: "Meera Singh", product: "Introducer Bonus Trigger", amount: 1000, commission: 250 },
      { sn: 2, userName: "Lata Bai", product: "Network Expansion", amount: 1000, commission: 250 },
    ],
    4: [
      { sn: 1, userName: "Rajesh Verma", product: "Quarterly Target Met", amount: 5000, commission: 1250 },
      { sn: 2, userName: "Sita Devi", product: "Multiple Referrals", amount: 10000, commission: 2500 },
    ],
    5: [
      { sn: 1, userName: "Anita Sharma", product: "Level 3 Cascade", amount: 4000, commission: 1000 },
      { sn: 2, userName: "Priya Patel", product: "Ongoing Bonus", amount: 4000, commission: 1000 },
    ],
    6: [
      { sn: 1, userName: "Neha Gupta", product: "Annual Milestone", amount: 20000, commission: 5000 },
      { sn: 2, userName: "Amit Joshi", product: "Yearly Network Growth", amount: 30000, commission: 7500 },
    ],
    7: [
      { sn: 1, userName: "Ritu Devi", product: "Weekly Challenge", amount: 750, commission: 188 },
      { sn: 2, userName: "Meera Singh", product: "Daily Introductions", amount: 750, commission: 188 },
    ],
    8: [
      { sn: 1, userName: "Lata Bai", product: "Level 4 Expansion", amount: 2000, commission: 500 },
      { sn: 2, userName: "Suresh Kumar", product: "Referral Chain", amount: 2000, commission: 500 },
    ],
  };

  const filteredRecords = dummyRecords.filter((rec) => {
    const recFrom = new Date(rec.fromDate);
    const recTo = new Date(rec.toDate);
    const filterFrom = new Date(fromDate);
    const filterTo = new Date(toDate);
    return (
      recFrom >= filterFrom &&
      recTo <= filterTo &&
      (selectedLevel === "All" || rec.level === selectedLevel)
    );
  });

  const totalAmount = filteredRecords.reduce((sum, rec) => sum + rec.amount, 0);
  const recordCount = filteredRecords.length;

  const groupedRecords = filteredRecords.reduce((acc, rec) => {
    if (!acc[rec.period]) acc[rec.period] = {};
    if (!acc[rec.period][rec.level]) acc[rec.period][rec.level] = [];
    acc[rec.period][rec.level].push(rec);
    return acc;
  }, {});

  const selectedContributors = selectedRecordId ? dummyContributors[selectedRecordId] || [] : [];

  if (!showSample) {
    return (
      <div className="min-h-screen bg-black">
        <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
          {/* Header */}
          <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
            <div className="flex flex-col">
              <div className="text-xl lg:text-2xl font-bold text-pink-400">💖 SheEarns Introducer</div>
              <div className="text-[10px] lg:text-lg text-yellow-200">
                My Introducer Bonus Income
              </div>
            </div>

            {/* Desktop user controls */}
            <div className="hidden md:flex items-center gap-3">
              {isLoggedIn ? (
                <>
                  <div className="text-xs text-left text-pink-300">{userName}</div>
                  <button
                    onClick={handleLogout}
                    className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => navigate("/login")}
                    className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
                  >
                    Login
                  </button>
                  <button
                    onClick={() => navigate("/signup")}
                    className="px-3 py-1 rounded-full bg-pink-500 text-white text-sm hover:bg-pink-400"
                  >
                    Register
                  </button>
                </>
              )}
            </div>

            {/* Mobile hamburger */}
            <button
              onClick={() => setIsMobileMenuOpen((s) => !s)}
              className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? "×" : "☰"}
            </button>
          </header>

          {/* Mobile menu content */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 animate-fadeIn">
              {isLoggedIn ? (
                <div className="flex flex-row items-center justify-center gap-3">
                  <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                    {userName}
                  </span>
                  <button
                    onClick={handleLogout}
                    className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </div>
              ) : (
                <div className="flex flex-row items-center justify-center gap-6">
                  <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                    Login
                  </Link>
                  <span className="text-pink-500">|</span>
                  <Link to="/signup" className="text-pink-300 hover:text-yellow-300">
                    Register
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* Main Content */}
          <main className="flex-1 py-8 px-4 text-center">
            <div className="max-w-md mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-pink-400 mb-6">
                Introducer Bonus Dashboard
              </h1>
              <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
                You have not started your introducer journey yet! Click Explore How My Income Will Look Like button below to see a sample income info.
              </p>
              <button
                onClick={() => setShowSample(true)}
                className="bg-gradient-to-r from-pink-500 to-pink-600 text-white font-semibold py-3 px-8 rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition w-full sm:w-auto"
              >
                Explore How My Income Will Look Like
              </button>
            </div>
          </main>

          {/* Footer */}
          <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4 mt-auto">
            <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
              <div className="text-xs lg:text-sm">
                © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
              </div>
              <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
                <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
                <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
        {/* Header */}
        <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
          <div className="flex flex-col">
            <div className="text-xl lg:text-2xl font-bold text-pink-400">💖 SheEarns Introducer</div>
            <div className="text-[10px] lg:text-lg text-yellow-200">
              My Introducer Bonus Income
            </div>
          </div>

          {/* Desktop user controls */}
          <div className="hidden md:flex items-center gap-3">
            {isLoggedIn ? (
              <>
                <div className="text-xs text-left text-pink-300">{userName}</div>
                <button
                  onClick={handleLogout}
                  className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                  title="Logout"
                >
                  ⏻
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => navigate("/login")}
                  className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
                >
                  Login
                </button>
                <button
                  onClick={() => navigate("/signup")}
                  className="px-3 py-1 rounded-full bg-pink-500 text-white text-sm hover:bg-pink-400"
                >
                  Register
                </button>
              </>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </header>

        {/* Mobile menu content */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 animate-fadeIn">
            {isLoggedIn ? (
              <div className="flex flex-row items-center justify-center gap-3">
                <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                  Welcome, {userName}
                </span>
                <button
                  onClick={handleLogout}
                  className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                  title="Logout"
                >
                  ⏻
                </button>
              </div>
            ) : (
              <div className="flex flex-row items-center justify-center gap-6">
                <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                  Login
                </Link>
                <span className="text-pink-500">|</span>
                <Link to="/signup" className="text-pink-300 hover:text-yellow-300">
                  Register
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Main Content */}
        <main className="flex-1 py-6 px-4">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold text-pink-400 mb-6 text-center">
              Sample Introducer Income Records for the period {periodType} {fromDate} to {toDate} for Level {selectedLevel}
            </h1>

            {/* Filters */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
              <select
                value={periodType}
                onChange={(e) => setPeriodType(e.target.value)}
                className="bg-gray-800 text-pink-100 px-3 py-2 h-10 rounded-lg border border-pink-500 focus:outline-none focus:border-pink-400"
              >
                <option>Yearly</option>
                <option>Quarterly</option>
                <option>Monthly</option>
                <option>Weekly</option>
                <option>Daily</option>
              </select>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="bg-gray-800 text-pink-100 px-3 py-2 rounded-lg border border-pink-500 focus:outline-none focus:border-pink-400"
              />
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="bg-gray-800 text-pink-100 px-3 py-2 rounded-lg border border-pink-500 focus:outline-none focus:border-pink-400"
              />
              <select
                value={selectedLevel}
                onChange={(e) => setSelectedLevel(e.target.value)}
                className="bg-gray-800 text-pink-100 px-3 py-2 h-10 rounded-lg border border-pink-500 focus:outline-none focus:border-pink-400"
              >
                <option>All</option>
                <option>L1</option>
                <option>L2</option>
                <option>L3</option>
                <option>L4</option>
                <option>L5</option>
                <option>L6</option>
                <option>L7</option>
                <option>L8</option>
              </select>
            </div>

            {/* Totals */}
            <div className="bg-gray-800 rounded-lg p-4 mb-6 text-center">
              <p className="text-pink-400 font-semibold">
                Total Records: {recordCount} | Total Amount: ₹{totalAmount.toLocaleString()}
              </p>
            </div>

            {/* Grouped Records List */}
            <div className="space-y-6 mb-6">
              {Object.entries(groupedRecords).map(([period, levels]) => (
                <div key={period} className="bg-gray-800 rounded-lg p-4">
                  <h3 className="text-xl font-bold text-pink-400 mb-3">{period}</h3>
                  {Object.entries(levels).map(([lvl, recs]) => (
                    <div key={lvl} className="mb-4">
                      <h4 className="text-lg font-semibold text-pink-300 mb-2">Level {lvl}</h4>
                      <div className="space-y-2">
                        {recs.map((rec) => (
                          <div
                            key={rec.id}
                            onClick={() => setSelectedRecordId(selectedRecordId === rec.id ? null : rec.id)}
                            className="cursor-pointer bg-gray-700 rounded-lg p-3 hover:bg-gray-600 transition flex justify-between items-center"
                          >
                            <div>
                              <span className="font-medium">SN: {rec.sn}</span> | 
                              <span className="ml-2">From: {rec.fromDate}</span> | 
                              <span className="ml-2">To: {rec.toDate}</span>
                            </div>
                            <div className="font-bold text-pink-400">₹{rec.amount.toLocaleString()}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            {/* Selected Record Contributors */}
            {selectedRecordId && (
              <div className="bg-gray-800 rounded-lg p-4">
                <h3 className="text-xl font-bold text-pink-400 mb-3">Contributing Users for Selected Record</h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-pink-500">
                    <thead>
                      <tr className="bg-pink-900">
                        <th className="border border-pink-500 p-3 text-left text-pink-200">SN</th>
                        <th className="border border-pink-500 p-3 text-left text-pink-200">User Name</th>
                        <th className="border border-pink-500 p-3 text-left text-pink-200">Product</th>
                        <th className="border border-pink-500 p-3 text-left text-pink-200">Amount (₹)</th>
                        <th className="border border-pink-500 p-3 text-left text-pink-200">Commission (₹)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedContributors.map((contrib) => (
                        <tr key={contrib.sn} className="hover:bg-gray-700 transition">
                          <td className="border border-pink-500 p-3">{contrib.sn}</td>
                          <td className="border border-pink-500 p-3">{contrib.userName}</td>
                          <td className="border border-pink-500 p-3">{contrib.product}</td>
                          <td className="border border-pink-500 p-3">₹{contrib.amount.toLocaleString()}</td>
                          <td className="border border-pink-500 p-3 font-semibold text-green-400">₹{contrib.commission.toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4 mt-auto">
          <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs lg:text-sm">
              © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
              <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default SheEarnsIntroducerIncome;